import React from 'react';
import _ from 'underscore';
import { titleize } from 'underscore.string';

import ExternalLinkIcon from 'components/v2/icons/ExternalLinkIcon';
import { unescapeSpecialChars } from 'src/main/js/helpers/helper_functions';

const getCustomerName = (user = {}) => {
  let name = '';

  if (user._type === 'Shipper') {
    name = user.company_name;
  } else if (user._type === 'Carrier') {
    name = user.name;
  } else if (user._type === 'Consignee') {
    name = user.company_name;
  } else if (user._type === 'Driver') {
    name = `${user.first_name} ${user.last_name}`;
  }

  return unescapeSpecialChars(`${titleize(name).trim()}`);
};

/*
 * A customer component that allows profile pages to be visited.
 */
export default function CustomerTableCell({ user, clickable }) {
  if (_.isEmpty(user)) {
    return null;
  }

  const name = getCustomerName(user);

  return (
    <div>
      {clickable && (
        <a href={`/users/${user._id}`}>
          <div className="flex justify-between">
            <div>
              <span>{name}</span>
            </div>
            <div>
              <ExternalLinkIcon className="w-4 h-4" />
            </div>
          </div>
        </a>
      )}
      {!clickable && <span>{name}</span>}
    </div>
  );
}
